var __rest =
  (this && this.__rest) ||
  function (s, e) {
    var t = {};
    for (var p in s)
      if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === 'function')
      for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
        if (
          e.indexOf(p[i]) < 0 &&
          Object.prototype.propertyIsEnumerable.call(s, p[i])
        )
          t[p[i]] = s[p[i]];
      }
    return t;
  };
import React from 'react';
import {
  ALIGN,
  AUTO,
  CLR,
  COL,
  LG,
  MD,
  OFFSET,
  ORDER,
  SELF,
  SM,
  XL,
  XS
} from '../../constants';
import classes from '../../utils/classes';
import cssPrefix from '../../utils/cssPrefix';
import withMemoRef from '../../utils/withMemoRef';
/**
 * Column prefix.
 */
const columnPrefix = cssPrefix(CLR, COL);
/**
 * Column sm prefix.
 */
const columnSmPrefix = cssPrefix(CLR, COL, SM);
/**
 * Column md prefix.
 */
const columnMdPrefix = cssPrefix(CLR, COL, MD);
/**
 * Column lg prefix.
 */
const columnLgPrefix = cssPrefix(CLR, COL, LG);
/**
 * Column xl prefix.
 */
const columnXlPrefix = cssPrefix(CLR, COL, XL);
/**
 * Column offset prefix.
 */
const offsetPrefix = cssPrefix(CLR, OFFSET);
/**
 * Column offset sm prefix.
 */
const offsetSmPrefix = cssPrefix(CLR, OFFSET, SM);
/**
 * Column offset md prefix.
 */
const offsetMdPrefix = cssPrefix(CLR, OFFSET, MD);
/**
 * Column offset lg prefix.
 */
const offsetLgPrefix = cssPrefix(CLR, OFFSET, LG);
/**
 * Column offset xl prefix.
 */
const offsetXlPrefix = cssPrefix(CLR, OFFSET, XL);
/**
 * Column order prefix.
 */
const columnOrderPrefix = cssPrefix(CLR, ORDER);
/**
 * Column align prefix.
 */
const columnAlignPrefix = cssPrefix(CLR, ALIGN, SELF);
/**
 * Column align xs prefix.
 */
const columnAlignXsPrefix = cssPrefix(CLR, ALIGN, SELF, XS);
/**
 * Column align sm prefix.
 */
const columnAlignSmPrefix = cssPrefix(CLR, ALIGN, SELF, SM);
/**
 * Column align md prefix.
 */
const columnAlignMdPrefix = cssPrefix(CLR, ALIGN, SELF, MD);
/**
 * Column align lg prefix.
 */
const columnAlignLgPrefix = cssPrefix(CLR, ALIGN, SELF, LG);
/**
 * Column align xl prefix.
 */
const columnAlignXlPrefix = cssPrefix(CLR, ALIGN, SELF, XL);
/**
 * Column component.
 *
 * @param props Column properties.
 */
export const Column = withMemoRef('Column', (_a, ref) => {
  var {
      align,
      alignLg,
      alignMd,
      alignSm,
      alignXl,
      alignXs,
      autoLg,
      autoMd,
      autoSm,
      autoXl,
      autoXs,
      className,
      offset,
      offsetLg,
      offsetMd,
      offsetSm,
      offsetXl,
      offsetXs,
      order,
      span,
      spanLg,
      spanMd,
      spanSm,
      spanXl,
      spanXs
    } = _a,
    props = __rest(_a, [
      'align',
      'alignLg',
      'alignMd',
      'alignSm',
      'alignXl',
      'alignXs',
      'autoLg',
      'autoMd',
      'autoSm',
      'autoXl',
      'autoXs',
      'className',
      'offset',
      'offsetLg',
      'offsetMd',
      'offsetSm',
      'offsetXl',
      'offsetXs',
      'order',
      'span',
      'spanLg',
      'spanMd',
      'spanSm',
      'spanXl',
      'spanXs'
    ]);
  return React.createElement(
    'div',
    Object.assign(
      {
        className: classes(
          columnPrefix(),
          {
            [columnPrefix(span)]: span,
            [columnPrefix(spanXs)]: spanXs,
            [columnPrefix(SM)]: spanSm,
            [columnSmPrefix(spanSm)]: spanSm,
            [columnPrefix(MD)]: spanMd,
            [columnMdPrefix(spanMd)]: spanMd,
            [columnPrefix(LG)]: spanLg,
            [columnLgPrefix(spanLg)]: spanLg,
            [columnPrefix(XL)]: spanXl,
            [columnXlPrefix(spanXl)]: spanXl
          },
          {
            [offsetPrefix(offset)]: offset,
            [offsetPrefix(offsetXs)]: offsetXs,
            [offsetSmPrefix(offsetSm)]: offsetSm,
            [offsetMdPrefix(offsetMd)]: offsetMd,
            [offsetLgPrefix(offsetLg)]: offsetLg,
            [offsetXlPrefix(offsetXl)]: offsetXl
          },
          {
            [columnPrefix(AUTO)]: autoXs,
            [columnSmPrefix(AUTO)]: autoSm,
            [columnMdPrefix(AUTO)]: autoMd,
            [columnLgPrefix(AUTO)]: autoLg,
            [columnXlPrefix(AUTO)]: autoXl
          },
          {
            [columnOrderPrefix(order)]: order,
            [columnAlignPrefix(align)]: align,
            [columnAlignXsPrefix(alignXs)]: alignXs,
            [columnAlignSmPrefix(alignSm)]: alignSm,
            [columnAlignMdPrefix(alignMd)]: alignMd,
            [columnAlignLgPrefix(alignLg)]: alignLg,
            [columnAlignXlPrefix(alignXl)]: alignXl
          },
          className
        )
      },
      Object.assign(Object.assign({}, props), { ref })
    )
  );
});
export default Column;
